export const DEFAULT_FAQ_PAGE_SIZE = 8;
export const DEFAULT_FAQ_PAGE_SIZES = [8, 12, 16, 20];